import { PrismicDocument } from '@prismicio/client';
import { ProductCatalogService, SelfcareService } from '@yol-digital/ms-client';
import { Redirect, RedirectResponse } from 'interfaces';

export const findConditionalRedirect = (
  landingPageResp: PrismicDocument,
  subscriptions: SelfcareService.SubscriptionsResp[] | null,
  rateplans: ProductCatalogService.CatalogResponse[],
  oldState: { prepaid: number; postpaid: number; mobilePostpaid: number } | undefined
) => {
  // Remove any redirects that don't have a redirect_url (as they break things)
  let redirects: Redirect[] = landingPageResp.data.redirects
    .filter((r: RedirectResponse) => r.redirect_url !== null)
    .map((r: RedirectResponse) => new Redirect(r));

  let postpaidSubs: SelfcareService.SubscriptionsResp[] = [],
    prepaidSubs: SelfcareService.SubscriptionsResp[] = [];
  if (subscriptions) {
    postpaidSubs = subscriptions.filter(s => {
      const product = rateplans.find(r => r.code === s.productCode.toUpperCase());
      return s.subscriptionStatus === 'active' && product?.productSpecCategory === 'POSTPAID';
    });
    prepaidSubs = subscriptions.filter(s => {
      const product = rateplans.find(r => r.code === s.productCode.toUpperCase());
      return s.subscriptionStatus === 'active' && product?.productSpecCategory === 'PREPAID';
    });
  }

  const mobilePostpaidSub = postpaidSubs.find(s => {
    const product = rateplans.find(r => r.code === s.productCode.toUpperCase());
    return product.productSpecFamily === 'MOBILE';
  });

  // Filtering based on logged in state
  redirects = redirects.filter(redirect => {
    if (redirect.loggedInStatus === 'all') return true;
    if (redirect.loggedInStatus === 'loggedIn' && subscriptions) return true;
    if (redirect.loggedInStatus === 'notLoggedIn' && !subscriptions) return true;
    if (redirect.loggedInStatus === 'loggedInOrWas' && (subscriptions || oldState)) return true;
    if (redirect.loggedInStatus === 'notLoggedInButWas' && !subscriptions && oldState) return true;
  });

  // Finding the first relevant one based on the customer type field
  return redirects.find(redirect => {
    if (!subscriptions && ['notLoggedIn'].includes(redirect.loggedInStatus)) return true;
    if (subscriptions && ['loggedIn', 'loggedInOrWas'].includes(redirect.loggedInStatus)) {
      if (redirect.customerType === 'all') return true;
      if (redirect.customerType === 'postpaid' && postpaidSubs.length) return true;
      if (redirect.customerType === 'prepaid' && prepaidSubs.length) return true;
      if (redirect.customerType === 'postpaidOnly' && postpaidSubs.length && !prepaidSubs.length) return true;
      if (redirect.customerType === 'prepaidOnly' && !postpaidSubs.length && prepaidSubs.length) return true;
      if (redirect.customerType === 'postpaidVoice' && mobilePostpaidSub) return true;
      if (redirect.customerType === 'noPostpaidVoice' && !mobilePostpaidSub) return true;
    }
    if (oldState && ['notLoggedInButWas', 'loggedInOrWas'].includes(redirect.loggedInStatus)) {
      if (redirect.customerType === 'all') return true;
      if (redirect.customerType === 'postpaid' && oldState.postpaid) return true;
      if (redirect.customerType === 'prepaid' && oldState.prepaid) return true;
      if (redirect.customerType === 'postpaidOnly' && oldState.postpaid && !oldState.prepaid) return true;
      if (redirect.customerType === 'prepaidOnly' && !oldState.postpaid && oldState.prepaid) return true;
      if (redirect.customerType === 'postpaidVoice' && oldState.mobilePostpaid) return true;
      if (redirect.customerType === 'noPostpaidVoice' && !oldState.mobilePostpaid) return true;
    }
  });
};
